import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './reducer/cart';


const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
});

export default store;

/*import { CreateSlice } from "@reduxjs/toolkit";


export const cartSlice = CreateSlice({
    name: 'cart',
    initialState: {
        list: [],
    },
    reducers: {
        additem: (state, { payload }) => {
            state.list = [...state.list, payload]
        },
    },
});

export const { addItem } = cartSlice.actions;

export default cartSlice.reducer;
*/